module.exports = __webpack_public_path__ + "img/3d.1c268e13.png";